var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs",class:{
    'border-bottom-none px-4 px-md-0': _vm.isProjectReview,
    'border-gray mb-7': _vm.isSimpleTab
  }},[(_vm.isProjectReview)?_vm._l((_vm.arrObj),function(obj,i){return _c('li',{key:obj.title,staticClass:"text-center reviewer-tab-list project-review-hover nav-item",class:{
        'active': _vm.activeTab === i,
        'disabled-white': _vm.disabled,
        'active-green': _vm.activeTab === 0,
        'active-orange': _vm.activeTab === 1,
        'active-red': _vm.activeTab === 2,
        'active-purple': _vm.activeTab === 3,
        'active-blue': _vm.activeTab === 4
      }},[_c('a',{staticClass:"nav-link text-black text-left pl-3",class:{
          'disabled': _vm.activeTab === i,
          'can-not-click disabled': _vm.disabled,
          'project-review-link': !_vm.disabled,
        },attrs:{"type":"button"},on:{"click":function($event){return _vm.switchTab(i)}}},[(!_vm.disabled)?_c('div',{staticClass:"box",class:{
            'green-box': i === 0,
            'orange-box': i === 1,
            'red-box': i === 2,
            'purple-box': i === 3,
            'blue-box': i === 4,
          }}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"reviewer-tab"},[_c('span',{class:{ 'ml-3': !_vm.disabled }},[_vm._v(_vm._s(obj.title))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"roll-font"},[_vm._v(_vm._s(obj.role))])])])])}):(_vm.isSimpleTab)?_vm._l((_vm.arrObj),function(obj,i){return _c('li',{key:obj.title,staticClass:"text-center simple-tab-item",class:{ 'active': _vm.activeTab === i, 'company-detail-tab-width' : _vm.isCompanyDetail }},[_c('a',{class:{
          'text-commit-blue': _vm.activeTab === i,
          'text-dark-gray': _vm.activeTab !== i,
          'can-not-click disabled': _vm.disabled
        },attrs:{"href":obj.path,"type":"button"}},[_c('span',{staticClass:"mr-1"},[_vm._v("\n          "+_vm._s(obj.title)+"\n        ")]),_vm._v(" "),(i === 1)?_c('span',{staticClass:"counter-badge counter font-extrasmall"},[_vm._v("\n          "+_vm._s(_vm.caseStudyCounter)+"\n        ")]):_vm._e()])])}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }